import script from "./Provisions.vue?vue&type=script&setup=true&lang=js"
export * from "./Provisions.vue?vue&type=script&setup=true&lang=js"

import "./Provisions.vue?vue&type=style&index=0&id=4c43f298&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c43f298"]])

export default __exports__